import IconBook from 'components/icons/book';
import IconCash from 'components/icons/cash';
import { IconChart } from 'components/icons/chart';
import IconMarketplace from 'components/icons/marketplace';
import IconPeople from 'components/icons/people';

import i18next from 'locales/i18next';

import RoutePath from 'router/path';

import { MenuItem } from 'types/routing';

import { LABELS } from '../keys';

const { t } = i18next;

export const menuItems: MenuItem[] = [
  {
    subheader: t('Pay with crypto'),
  },
  {
    label: t('Orders'),
    icon: IconCash,
    to: RoutePath.Pwc.Orders.Root,
  },
  {
    label: t('Customers'),
    icon: IconPeople,
    to: RoutePath.Pwc.Customers.Root,
  },
  {
    subheader: t(LABELS.CRYPTO_PAYOUT_MENU_ITEM_SUBHEADER),
  },
  {
    label: t(LABELS.PAYOUTS_MENU_ITEM),
    icon: IconChart,
    to: RoutePath.CryptoPayout.Payouts.Root,
  },
  {
    subheader: t('General'),
  },
  {
    label: t('Merchant Accounts'),
    icon: IconMarketplace,
    to: RoutePath.Pwc.Accounts.Root,
  },
  {
    label: t('Documentation'),
    icon: IconBook,
    openInNewWindow: true,
    to: window?.s4cConfig?.documentationUrl || '',
  },
];

export default menuItems;
